/**
 * Determine which Genie spaces should be exposed in the UI for the active user.
 * DIFOT remains role-gated; the other configured Genie spaces are default-on.
 */

import { useState, useEffect } from 'react';
import { msalInstance } from '../api/auth';
import { AGENT_IDS } from '../constants/agents';
import { useChatStore } from '../stores/chatStore';

export function useGenieAccess() {
  const [allowedGenieSpaceNames, setAllowedGenieSpaceNames] = useState<string[]>([]);
  const [hasGenieAccess, setHasGenieAccess] = useState<boolean>(false);

  // Get methods from chat store to update Genie access state
  const setStoreGenieAccess = useChatStore(state => state.setGenieAccess);
  const setStoreAllowedGenieSpaceNames = useChatStore(state => state.setAllowedGenieSpaceNames);

  // Use useEffect to run the check only once per render
  useEffect(() => {
    const checkRoles = async () => {
      const account = msalInstance.getActiveAccount();
      const allowedSpaces: string[] = [];

      if (account) {
        const roles = account.idTokenClaims?.roles || [];

        if (roles.includes('CoopGPT.StructuredData.DIFOT')) {
          allowedSpaces.push(AGENT_IDS.DIFOT);
        }

        allowedSpaces.push(AGENT_IDS.WHUTIL);
        allowedSpaces.push(AGENT_IDS.ARI);
        allowedSpaces.push(AGENT_IDS.SHAREPOINT);
      }

      setAllowedGenieSpaceNames(allowedSpaces);

      const hasAccess = allowedSpaces.length > 0;
      setHasGenieAccess(hasAccess);
      setStoreGenieAccess(hasAccess);
      setStoreAllowedGenieSpaceNames(allowedSpaces);
    };

    checkRoles();
  }, [setStoreAllowedGenieSpaceNames, setStoreGenieAccess]);

  return {
    allowedGenieSpaceNames,
    hasGenieAccess
  };
}
